import { BaseModel, Guid, RecursivePartial } from '@models/base';
import { getUuid } from '@models/utils/uuid';

export class TaskChecklistItem extends BaseModel {
    title: string = '';
    checked?: boolean;

    _id?: Guid;

    constructor(json?: RecursivePartial<TaskChecklistItem>) {
        super(json);
        this.parseTaskChecklistItem(json || {});
    }

    parse(json: RecursivePartial<TaskChecklistItem>): TaskChecklistItem {
        super.parse(json);
        this.parseTaskChecklistItem(json);
        return this;
    }

    private parseTaskChecklistItem(json: RecursivePartial<TaskChecklistItem>): void {
        TaskChecklistItem.assignFields<TaskChecklistItem>(this, json, ['title', 'checked', '_id']);
        if (!this._id) {
            this._id = getUuid();
        }
    }

}
